import { FC, useState } from "react";
import './index.css';

type Props = {
    message: string;
};

const LoadingScreen = ({ message }: Props) => {
    return (
        <div className="loading-screen">
            <div className="loading-message">
                <div style={{ padding: 10, textAlign: "center" }}>
                    <p key='msg'>{message}</p>
                </div>
            </div>
        </div>
    );
};

export default LoadingScreen;